import React from 'react';

import * as styles from './AlertMessage.module.scss';

type Props = {
  content: string;
};

export const AlertMessage: React.FC<Props> = ({ content }) => (
  <div className={styles.root}>
    <p>{content}</p>
  </div>
);
